"use strict";
'use es6';
/*
  Transforms an `InteractionRecord` to a `LocalInteraction` for local storage.
  Interactions that require more than this should write additional transforms.
*/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toLocalInteraction = toLocalInteraction;
exports.toInteractionRecord = toInteractionRecord;

function toLocalInteraction(interactionRecord, localInteraction) {
  return localInteraction.set('task', {
    metadata: interactionRecord.metadata,
    engagement: interactionRecord.engagement,
    associations: interactionRecord.associations
  });
}

function toInteractionRecord(localInteraction, interactionRecord) {
  var task = localInteraction.get('task');

  if (!task) {
    return interactionRecord;
  }

  var metadata = task.get('metadata').merge(interactionRecord.metadata);
  var engagement = task.get('engagement').merge(interactionRecord.engagement);
  var associations = task.get('associations').merge(interactionRecord.associations);
  return interactionRecord.set('metadata', metadata).set('engagement', engagement).set('associations', associations);
}